// extracted by mini-css-extract-plugin
export default {"container":"styles_container__VwFJI","loader":"styles_loader__1cZpg","lds-roller":"styles_lds-roller__NHgku"};